import {makeStyles, Theme, createStyles} from "@material-ui/core";

const useClasses = makeStyles((theme: Theme) => createStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%"
    },
    container: {
        marginTop: theme.spacing(2)
    }
}));

export default useClasses;
